import ConnectedComparePlayer from './ComparePlayer';

export default ConnectedComparePlayer;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/ComparePlayer/index.js